module.exports = __webpack_public_path__ + "public/images/generated-cartoon-drawing.90126736979cb410733b3464cc2c3c70.jpg";